import ActionTypes from '../constants/ActionTypes'; 

const initialState = {
    loading: false,
    data: {},
    dataLogin: {},
    error: null,
};

const loginHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_LOGIN_HISTORY_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.FETCH_LOGIN_HISTORY_SUCCESS:
            return { ...state, loading: false, data: action.payload};
        case ActionTypes.FETCH_LOGIN_HISTORY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ActionTypes.FETCH_GET_LOGIN_HISTORY_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.FETCH_GET_LOGIN_HISTORY_SUCCESS:
            return { ...state, loading: false, dataLogin: action.payload};
        case ActionTypes.FETCH_GET_LOGIN_HISTORY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default loginHistoryReducer;
